import CardLogin from './CardLogin';

export default CardLogin;
